<section class="cmn-innerpage-wrapper add-project-inventory">
  <h2 class="cmn-inner-heading">
    {{ customerId ? "Edit Customer" : "New Customer" }}
  </h2>
  <form [formGroup]="newCustomerForm" (ngSubmit)="onSubmit()">
    <!-- Format Selection -->
    <div class="chart-account-form-wrapper">
      <div class="form-wrapper">
        <label for="">First Name <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter First Name"
            formControlName="firstName"
          />
        </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="
                newCustomerForm.get('firstName')!.touched &&
                newCustomerForm.get('firstName')!.hasError('required')
              "
              >First name is required.</mat-error
            >
          </span>
          <span>
            <mat-error
              *ngIf="newCustomerForm.get('firstName')!.hasError('maxlength')"
              >First name must be at most 50 characters long.</mat-error
            >
          </span>
        </div>
      </div>
      <div class="form-wrapper">
        <label for="">Last Name <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Last Name"
            formControlName="lastName"
          />
        </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="
                newCustomerForm.get('lastName')!.touched &&
                newCustomerForm.get('lastName')!.hasError('required')
              "
              >Last name is required.</mat-error
            >
          </span>
          <span>
            <mat-error
              *ngIf="
                newCustomerForm.get('lastName')!.touched &&
                newCustomerForm.get('lastName')!.hasError('maxlength')
              "
              >Last name must be at most 50 characters long.</mat-error
            >
          </span>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Customer Email <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter email address"
            formControlName="email"
          />
        </mat-form-field>

        <div class="custom-error" *ngIf="newCustomerForm.get('email')!.touched">
          <span>
            <mat-error
              *ngIf="
                newCustomerForm.get('email')!.touched &&
                newCustomerForm.get('email')!.hasError('maxlength')
              "
              >Email must be at most 50 characters long.</mat-error
            >
          </span>
          <span>
            <mat-error
              *ngIf="newCustomerForm.get('email')!.hasError('required')"
              >Email ID is required.
              <!-- Required Error - shows only if empty -->
            </mat-error>
          </span>
          <span>
            <!-- Invalid Email Format Error - shows only if not empty but invalid -->
            <mat-error
              *ngIf="
                newCustomerForm.get('email')!.hasError('invalidEmail') &&
                !newCustomerForm.get('email')!.hasError('required')
              "
              >Please enter a valid email address.</mat-error
            >
          </span>
        </div>
      </div>
      <div class="form-wrapper" style="padding-top: 16px;">
        <label for="">Phone <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter phone number"
            formControlName="phone"
          />
        </mat-form-field>
        <div class="custom-error" *ngIf="newCustomerForm.get('phone')!.touched">
          <span>
            <mat-error
              *ngIf="newCustomerForm.get('phone')!.hasError('required')"
              >Phone number is required.</mat-error
            >
          </span>
          <span>
            <mat-error
              *ngIf="
                newCustomerForm.get('phone')!.hasError('minlength') &&
                !newCustomerForm.get('phone')!.hasError('required')
              "
            >
              Phone number must be at least 8 digits.</mat-error
            >
          </span>
          <span>
            <mat-error
              *ngIf="
                newCustomerForm.get('phone')!.hasError('maxlength') &&
                !newCustomerForm.get('phone')!.hasError('required')
              "
            >
              Phone number cannot exceed 15 digits.</mat-error
            >
          </span>
          <span>
            <mat-error
              *ngIf="
                newCustomerForm.get('phone')!.hasError('pattern') &&
                !newCustomerForm.get('phone')!.hasError('required')
              "
              >Invalid phone number. Only digits are allowed.</mat-error
            >
          </span>
        </div>
      </div>

      <div class="form-wrapper">
        <div class="whatsapp-form-section">
          <label for="">Whatsapp Number <span class="red">*</span></label>
          <mat-checkbox class="wp-checkbox" (change)="toggleSameAsPhone($event)">
            Same as phone number
          </mat-checkbox>
        </div>

        <mat-form-field>
          <input
            matInput
            placeholder="Enter Whatsapp number with country code"
            formControlName="whatsappNo"
          />
        </mat-form-field>
        <div
          class="custom-error"
          *ngIf="newCustomerForm.get('whatsappNo')!.touched"
        >
          <span>
            <mat-error
              *ngIf="newCustomerForm.get('whatsappNo')!.hasError('required')"
              >Whatsapp number is required.</mat-error
            >
          </span>
          <span>
            <mat-error
              *ngIf="
                newCustomerForm.get('whatsappNo')!.hasError('minlength') &&
                !newCustomerForm.get('whatsappNo')!.hasError('required')
              "
            >
              Whatsapp number must be at least 8 digits.</mat-error
            >
          </span>
          <span>
            <mat-error
              *ngIf="
                newCustomerForm.get('whatsappNo')!.hasError('maxlength') &&
                !newCustomerForm.get('whatsappNo')!.hasError('required')
              "
            >
              Whatsapp number cannot exceed 18 digits.</mat-error
            >
          </span>
          <span>
            <mat-error
              *ngIf="
                newCustomerForm.get('whatsappNo')!.hasError('pattern') &&
                !newCustomerForm.get('whatsappNo')!.hasError('required')
              "
              >Invalid Whatsapp number</mat-error
            >
          </span>
        </div>
      </div>

      <div class="form-wrapper" style="padding-top: 16px;">
        <label for="">Date of Birth <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <input
            matInput
            [matDatepicker]="dobPicker"
            placeholder="Select Date of Birth"
            formControlName="dateOfBirth"
            [max]="maxDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="dobPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #dobPicker></mat-datepicker>
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              newCustomerForm.get('dateOfBirth')!.touched &&
              newCustomerForm.get('dateOfBirth')!.hasError('required')
            "
          >
            Date of birth is required.
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Gender <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <mat-label>Choose Gender</mat-label>
          <mat-select formControlName="gender">
            <mat-option *ngFor="let type of genderData" [value]="type.value">
              {{ type.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="custom-error">
          <mat-error
            *ngIf="
              newCustomerForm.get('gender')!.touched &&
              newCustomerForm.get('gender')!.hasError('required')
            "
          >
            Gender is required.
          </mat-error>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Preferred Channels <span class="red">*</span></label>
        <mat-form-field appearance="fill">
          <mat-label>Choose preferences</mat-label>
          <mat-select formControlName="preference" multiple>
            <mat-option
              *ngFor="let type of preferenceData"
              [value]="type.value"
            >
              {{ type.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="custom-error">
          <mat-error
            *ngIf="
              newCustomerForm.get('preference')!.touched &&
              newCustomerForm.get('preference')!.hasError('required')
            "
          >
            At least one preference is required.
          </mat-error>
        </div>
      </div>
    </div>

    <div class="common-noimage-tab-wrapper">
      <mat-tab-group animationDuration="0ms">
        <!-- Mat Tab One -->
        <mat-tab>
          <ng-template mat-tab-label>
            <h2 class="leave-tab-title">Address</h2>
          </ng-template>
          <app-address
            [customerData]="customerData"
            (formSubmit)="collectAddress($event)"
          ></app-address>
        </mat-tab>
        <!-- Mat Tab Two -->
        <mat-tab>
          <ng-template mat-tab-label>
            <h2 class="leave-tab-title">Documents</h2>
          </ng-template>
          <app-customer-documents
            [customerData]="customerData"
            (formSubmit)="collectDocumentDetails($event)"
          ></app-customer-documents>
        </mat-tab>
      </mat-tab-group>
    </div>
    <!-- <div *ngIf="validationError" class="error" style="text-align: center; margin: 0">
                Please fill mandatory fields!
              </div> -->
    <div class="submit-btn-wrapper">
      <button class="cmn-cancel-btn" type="button" (click)="onCancel()">
        Cancel
      </button>
      <button class="cmn-next-btn" type="submit">Save</button>
    </div>
  </form>
</section>
